import { mayNudgeShow } from '@carvana/merch-nudge-manager/consumer';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import COOKIES from '~/constants/cookies';
import ModalContext from '~/context/srp/ModalContext';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';
import BrowserCookies from '~/utilities/BrowserCookies';
import { saveItemToLocalStorage } from '~/utilities/localStorage';
import useShouldShowNudge from './useShouldShowNudge';
import { localStorageKey } from '../constants';

export default function useShowSaveSearchNudge() {
  const { setSaveSearchNudgeOpen } = useContext(ModalContext);
  const { request } = useGenerateInventoryRequest(0);
  const { reset, shouldShowNudge } = useShouldShowNudge();
  const trackEvent = useTrackEvent();

  useSubsequentEffect(() => {
    if (!shouldShowNudge) return;

    mayNudgeShow('save-search').then(({ mayShow }) => {
      if (!mayShow) {
        reset();

        return;
      }

      setSaveSearchNudgeOpen(true);

      const bcid = BrowserCookies.get(COOKIES.browserCookieId);

      if (bcid) {
        saveItemToLocalStorage(localStorageKey, {
          [bcid]: new Date().toISOString()
        });
      }
    });
  }, [request, reset, setSaveSearchNudgeOpen, shouldShowNudge, trackEvent]);
}
